import { Phone, Mail, MapPin, Clock, Instagram, Facebook } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { LeadForm } from "../components/LeadForm";
import { Map } from "../components/Map";
import { SEO } from "../components/SEO";
import { SITE } from "../data/siteData";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SEO
        title="Contact Us | Chinook K9 Dog Training Calgary & Area"
        description="Contact Chinook K9 for dog training in Calgary and surrounding areas. Call 403-715-0499 or email training@chinookk9.com. Open 7 days a week."
        path="/contact"
      />

      <section className="bg-obsidian pt-40 pb-20 border-b border-white/10" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal>
            <p className="text-brand font-heading font-bold tracking-[0.3em] text-xs uppercase mb-4">Contact Us</p>
            <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-extrabold tracking-tighter text-white">
              Let's talk about your dog
            </h1>
          </Reveal>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-12">
            {[
              { icon: Phone, label: "Call Us", value: SITE.phone, href: SITE.phoneHref, testid: "contact-phone" },
              { icon: Mail, label: "Email", value: SITE.email, href: `mailto:${SITE.email}`, testid: "contact-email" },
              { icon: MapPin, label: "Location", value: "263001 Lochend Road, Rocky View County, AB", testid: "contact-address" },
              { icon: Clock, label: "Hours", value: SITE.hours, testid: "contact-hours" },
            ].map((c, i) => (
              <Reveal key={c.label} delay={i * 0.08}>
                <div className="bg-[#121212] border border-white/10 rounded-xl p-6 h-full" data-testid={c.testid}>
                  <c.icon size={20} className="text-brand mb-3" />
                  <p className="text-xs font-heading font-bold tracking-widest uppercase text-white/40 mb-1.5">{c.label}</p>
                  {c.href ? (
                    <a href={c.href} className="text-sm font-semibold text-white hover:text-brand transition-colors break-all">{c.value}</a>
                  ) : (
                    <p className="text-sm font-semibold text-white">{c.value}</p>
                  )}
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.35}>
            <div className="flex items-center gap-4 mt-8" data-testid="contact-socials">
              <span className="text-xs font-heading font-bold tracking-widest uppercase text-white/40">Follow us</span>
              <a href={SITE.instagram} target="_blank" rel="noreferrer" data-testid="contact-instagram"
                className="w-10 h-10 rounded-full bg-[#161616] border border-white/15 flex items-center justify-center text-white/70 hover:text-brand hover:border-brand/50 transition-colors" aria-label="Instagram">
                <Instagram size={17} />
              </a>
              <a href={SITE.facebook} target="_blank" rel="noreferrer" data-testid="contact-facebook"
                className="w-10 h-10 rounded-full bg-[#161616] border border-white/15 flex items-center justify-center text-white/70 hover:text-brand hover:border-brand/50 transition-colors" aria-label="Facebook">
                <Facebook size={17} />
              </a>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-obsidian py-24" data-testid="contact-form-section">
        <div className="max-w-3xl mx-auto px-6">
          <Reveal className="mb-10">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-white">Training enquiry form</h2>
          </Reveal>
          <Reveal delay={0.1}>
            <LeadForm />
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-24" data-testid="contact-map-section">
        <div className="max-w-7xl mx-auto px-6">
          <Reveal className="mb-10">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">Find us just outside Calgary</h2>
            <p className="mt-3 text-slate-600">{SITE.address} — minutes from Calgary, Cochrane and Airdrie.</p>
          </Reveal>
          <Reveal delay={0.1}>
            <Map height={480} />
          </Reveal>
        </div>
      </section>
    </div>
  );
}
